/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { useState } from 'react';

import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import StorageIcon from '@mui/icons-material/Storage';
import { Collapse, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';

import { AdminProject } from '../../../../../types/superuser/AdminProject';
import { AdminEmptyList } from '../../AdminEmptyList/AdminEmptyList';
import { useAdminOrganizationInfoListStyles } from '../AdminOrganizationInfoList.styles';

type OrganizationProjectsInfoListProps = {
  project: AdminProject;
};

export function OrganizationProjectsInfoList(props: OrganizationProjectsInfoListProps) {
  const classes = useAdminOrganizationInfoListStyles();
  const [openProject, setOpenProject] = useState(false);
  const { project } = props;

  return (
    <>
      <ListItem button onClick={() => setOpenProject(!openProject)}>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary={project.name} secondary={project.description} />
        {openProject ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={openProject} timeout="auto" unmountOnExit>
        <List component="div" disablePadding className={classes.nested}>
          {project.clusters.length ? (
            project.clusters.map(c => (
              <ListItem key={c.id}>
                <ListItemIcon>
                  <StorageIcon />
                </ListItemIcon>
                <ListItemText primary={c.name} secondary={c.description} />
              </ListItem>
            ))
          ) : (
            <AdminEmptyList />
          )}
        </List>
      </Collapse>
    </>
  );
}
